import * as Yup from 'yup';

import ServerMediaSchema from './MediaSchema';
// export const DonationsSchema = Yup.object({
//     occupation: Yup.string()
//         .trim()
//         .required('The occupation field is required.'),
//     company: Yup.string()
//         .trim()
//         .required('The company field is required.'),
//     amount_donate: Yup.string()
//         .trim()
//         .required('The amount_donate field is required.'),
//     payment_method: Yup.string()
//         .trim()
//         .required('The payment_method field is required.'),
//     // donated_to: Yup.string()
//     //     .trim()
//     //     .required('The donated_to field is required.'),
// })
export const DonationsSchema = {

    occupation: Yup.string()
        .trim()
        .required('The occupation field is required.'),
    company: Yup.string()
        .trim().nullable(),
    amount_donate: Yup.number()
        .required('The amount donate field is required.').min(1, 'The donation amount must be greater than 0.'),
    payment_method: Yup.string()
        .trim()
        .required('The payment method field is required.'),
    email: Yup.string()
        .trim()
        .email('Invalid email address')
        .required('The email field is required.'),
    // province: Yup.string().required('The province field is required.'),
    // city: Yup.string().required('The city field is required.'),
    // brgy: Yup.string().required('The barangay field is required.'),
    // address_line_1: Yup.string().required('The address line 1 field is required.'),
    donated_to: Yup.array()
        .required('The donated to field is required.'),
}


export const PersonValidation = {
    first_name: Yup.string()
        .trim()
        .required('The first name field is required.'),
    middle_name: Yup.string()
        .trim(),
    last_name: Yup.string()
        .trim()
        .required('The last name field is required.'),
    contact_no: Yup.string()
        .trim()
        .required('The contact no. field is required.'),
    honorifics: Yup.string().trim().optional().nullable(),
    others_honorifics: Yup.string().trim().optional().when('honorifics', {
        is: 'Others',
        then: Yup.string().trim().required('The honorifics field is required.')
    }),
    // gender: Yup.string()
    //     .trim().nullable(),
    // birthday: Yup.string()
    //     .trim().nullable(),
}
export const ProofOfPaymentSchema = {
    file: Yup.mixed().required('A Proof of Payment is required')
}
export const ClientDonationsSchema = Yup.object({
    ...DonationsSchema,
    ...PersonValidation,
    ...ProofOfPaymentSchema
})
export const DonationInfoSchema = Yup.object({
    ...DonationsSchema,
})
export const ServerDonationsSchema = Yup.object({
    donation: Yup.object().shape({
        ...DonationsSchema,
        donated_to: Yup.string().required('The donated to field is required.'),
    }),
    person: Yup.object().shape({
        ...PersonValidation
    }),
    media: Yup.object().shape({
        ...ProofOfPaymentSchema
    })
})

// export default DonationsSchema;
export const DonationDeleteSchema = Yup.object({
    id: Yup.number()
        .required('The donation ID is required.'),
})
export const DonationUpdateSchema = Yup.object({
    id: Yup.number()
        .required('The donation ID is required.')
})

export const DonationDetailsModalSchema = Yup.object({
    status:Yup.string().required("The status field is required").oneOf(["For Confirmation","Verified","Replied", "Processing Certificate", "Completed"], "Invalid Input"),
    donation_status: Yup.string().required("The payment status field is required").oneOf(["Pending","Verified"], "Invalid Input"),
    amount_donate: Yup.number().required("The contribution field is required").min(1, "Contribution must be greater than 0"),
})


// export default DonationsSchema